import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"
import { getToolMetadata } from "@/utils/tool-metadata"

type ToolsListProps = {
  tools: string
  className?: string
}

export function ToolsList({ tools, className }: ToolsListProps) {
  const { t } = useTranslation()

  const toolNames = tools
    .split(",")
    .map((tool) => tool.trim())
    .filter(Boolean)

  if (toolNames.length === 0) {
    return null
  }

  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      {toolNames.map((toolName, index) => {
        const metadata = getToolMetadata(toolName)
        const displayName = metadata
          ? t(`activity_messages.tool_${metadata.translationKey}`, {
              defaultValue: toolName,
            })
          : toolName

        return (
          <div
            key={`${toolName}-${index}`}
            className="bg-muted/20 ring-primary/10 flex items-center gap-1.5 rounded-md px-2.5 py-1 ring-1"
          >
            {metadata?.icon}
            <span className="text-foreground/80 text-xs font-medium">{displayName}</span>
          </div>
        )
      })}
    </div>
  )
}
